export default __webpack_public_path__ + "static/6-8d4e1bc53b12778656e0585240eb618f.png";